/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPNOTAXNUMBERREASON } from './IAPNOTAXNUMBERREASON';
import {
    IAPNOTAXNUMBERREASONFromJSON,
    IAPNOTAXNUMBERREASONFromJSONTyped,
    IAPNOTAXNUMBERREASONToJSON,
} from './IAPNOTAXNUMBERREASON';
import type { TaxRateViewModel } from './TaxRateViewModel';
import {
    TaxRateViewModelFromJSON,
    TaxRateViewModelFromJSONTyped,
    TaxRateViewModelToJSON,
} from './TaxRateViewModel';
import type { TaxViewModel } from './TaxViewModel';
import {
    TaxViewModelFromJSON,
    TaxViewModelFromJSONTyped,
    TaxViewModelToJSON,
} from './TaxViewModel';

/**
 * 
 * @export
 * @interface TaxDetailsViewModel
 */
export interface TaxDetailsViewModel {
    /**
     * 
     * @type {Array<TaxViewModel>}
     * @memberof TaxDetailsViewModel
     */
    otherPartyTaxes?: Array<TaxViewModel>;
    /**
     * 
     * @type {TaxViewModel}
     * @memberof TaxDetailsViewModel
     */
    primaryPartyTax?: TaxViewModel;
    /**
     * 
     * @type {TaxRateViewModel}
     * @memberof TaxDetailsViewModel
     */
    incomeTaxRate?: TaxRateViewModel;
    /**
     * 
     * @type {boolean}
     * @memberof TaxDetailsViewModel
     */
    isTaxNumberAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TaxDetailsViewModel
     */
    noTaxNumberCustomReason?: string;
    /**
     * 
     * @type {IAPNOTAXNUMBERREASON}
     * @memberof TaxDetailsViewModel
     */
    noTaxNumberReason?: IAPNOTAXNUMBERREASON;
}

/**
 * Check if a given object implements the TaxDetailsViewModel interface.
 */
export function instanceOfTaxDetailsViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TaxDetailsViewModelFromJSON(json: any): TaxDetailsViewModel {
    return TaxDetailsViewModelFromJSONTyped(json, false);
}

export function TaxDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaxDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'otherPartyTaxes': !exists(json, 'OtherPartyTaxes') ? undefined : ((json['OtherPartyTaxes'] as Array<any>).map(TaxViewModelFromJSON)),
        'primaryPartyTax': !exists(json, 'PrimaryPartyTax') ? undefined : TaxViewModelFromJSON(json['PrimaryPartyTax']),
        'incomeTaxRate': !exists(json, 'IncomeTaxRate') ? undefined : TaxRateViewModelFromJSON(json['IncomeTaxRate']),
        'isTaxNumberAvailable': !exists(json, 'IsTaxNumberAvailable') ? undefined : json['IsTaxNumberAvailable'],
        'noTaxNumberCustomReason': !exists(json, 'NoTaxNumberCustomReason') ? undefined : json['NoTaxNumberCustomReason'],
        'noTaxNumberReason': !exists(json, 'NoTaxNumberReason') ? undefined : IAPNOTAXNUMBERREASONFromJSON(json['NoTaxNumberReason']),
    };
}

export function TaxDetailsViewModelToJSON(value?: TaxDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'OtherPartyTaxes': value.otherPartyTaxes === undefined ? undefined : ((value.otherPartyTaxes as Array<any>).map(TaxViewModelToJSON)),
        'PrimaryPartyTax': TaxViewModelToJSON(value.primaryPartyTax),
        'IncomeTaxRate': TaxRateViewModelToJSON(value.incomeTaxRate),
        'IsTaxNumberAvailable': value.isTaxNumberAvailable,
        'NoTaxNumberCustomReason': value.noTaxNumberCustomReason,
        'NoTaxNumberReason': IAPNOTAXNUMBERREASONToJSON(value.noTaxNumberReason),
    };
}

